import { Typography } from "@suraasa/placebo-ui"
import { CircularProgress } from "@suraasa/placebo-ui"

type Props = {
  logo?: string
  message?: string
}

export default function FullPageLoading({ message = "" }: Props) {
  return (
    <div className="flex h-screen flex-col justify-center">
      <div className="flex justify-center">
        <div className="flex flex-col items-center justify-center">
          <CircularProgress size="lg" color="black" />
          {message && (
            <Typography variant="largeBody" className="mt-1 text-center">
              {message}
            </Typography>
          )}
        </div>
      </div>
    </div>
  )
}
